import Model  from '@/util/models';

export default class User extends Model { 
    backend = '/master/user/'; 
    
    indexAll(params){
        return this.api.get(this.backend + 'index-page', params).then(res => {          
          return res.status == 200 ? res.data : [];
        });
    }
    
    viewBranch(params){                        
        return this.api.post(this.backend + 'view-branch', {}, params); 
    }  
    
    assignBranch(items, params){                        
        return this.api.post(this.backend + 'assign-branch', items, params); 
    }    
    
    revokeBranch(items, params){                        
        return this.api.post(this.backend + 'revoke-branch', items, params); 
    } 
    
    setDefaultBranch(data){                        
        return this.api.post(this.backend + 'set-default-branch', data); 
    } 
    
    viewWarehouse(params){                        
        return this.api.post(this.backend + 'view-warehouse', {}, params); 
    }
    
    assignWarehouse(items, params){                        
        return this.api.post(this.backend + 'assign-warehouse', items, params); 
    }    
    
    revokeWarehouse(items, params){                        
        return this.api.post(this.backend + 'revoke-warehouse', items, params); 
    } 
    
    setDefaultWarehouse(data){                        
        return this.api.post(this.backend + 'set-default-warehouse', data); 
    } 
    
    setavatar(formdata){
        return this.api.post(this.backend + 'setavatar', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
    
    getavatar(params){
        return this.api.get(this.backend + 'getavatar', params); 
    }
    
    getavatarThumb(params){
        return this.api.get(this.backend + 'getavatar-thumb', params); 
    }

    profile(){
        return this.api.get(this.backend + 'profile');
    }
    
    updateProfile(body){
        return this.api.post(this.backend + 'profile-update', body);
    }
            
}

